import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import PublicLayout from "@/components/PublicLayout";
import { Breadcrumbs, CtaBanner } from "@/components/Marketing";
import { GUIDES } from "@/data/guides";
import { ArrowRight, BookOpen } from "lucide-react";

export default function Guides() {
  const entries = Object.entries(GUIDES);
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "Driver Guides",
    url: "https://eazycartrack.co.uk/guides",
    description: "Useful guides for private hire drivers in Manchester — licensing, insurance, costs and choosing a car.",
  };
  return (
    <PublicLayout>
      <Seo
        title="Driver Guides — Manchester PHV & Taxi Rental"
        description="Useful guides for private hire drivers in Manchester: how to get licensed, insurance explained, taxi rental costs, documents needed and the best cars for PHV work."
        path="/guides"
        jsonLd={jsonLd}
      />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Driver Guides" }]} />
      <div className="container-x py-8">
        <h1 className="font-heading text-4xl font-black uppercase tracking-tighter sm:text-5xl">Driver Guides</h1>
        <p className="mt-3 max-w-2xl text-zinc-600">
          Practical, honest guides for private hire drivers in Manchester — from getting licensed to choosing the
          right car. For official rules, we always point you to your licensing authority.
        </p>
        <div className="mt-10 grid gap-6 md:grid-cols-2">
          {entries.map(([slug, g]) => (
            <Link
              key={slug}
              to={`/guides/${slug}`}
              data-testid={`guide-card-${slug}`}
              className="group flex flex-col border border-border bg-white p-6 transition-colors hover:border-zinc-900"
            >
              <BookOpen className="h-7 w-7 text-[#00E676]" />
              <h2 className="mt-4 font-heading text-xl font-bold tracking-tight">{g.title}</h2>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-zinc-600">{g.excerpt}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-zinc-900">
                Read guide <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          ))}
        </div>
      </div>
      <CtaBanner />
    </PublicLayout>
  );
}
